// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_Njw","cls2":"CreateSocialItem-cls2_bha CreateSocialItem-cls1_Njw"};